import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';


export default class MSBService{

    static getMSBCommercialLoginURL(additionalHeaders={}){
        return JsonRPCService.send(
            getProxiedServiceUrl('constants'),
            'getMSBCommercialLoginURL',
            [],
            additionalHeaders);
    }

    static getMSBHoLaunchURL(sessionId, quoteId, additionalHeaders={}){
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayQuoteQuote'), 
            'getMsbLaunchUrl_TWIA', 
            [sessionId, quoteId], additionalHeaders);
    }

    // TWIA PE - Unable to Launch MSB. MSB Valuation Failed
    // Service returns the MSB Valuation URL if provided by MSB when an MSB error occurs, which can happen when the
    // provided address isn't found by MSB
    static getForceMSBHoLaunchURL(sessionId, quoteId, additionalHeaders={}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayQuoteQuote'), 
            'getForceMsbLaunchUrl_TWIA', 
            [sessionId, quoteId], additionalHeaders);
    }

    static refreshMSBValuation(sessionId, quoteId, quoteDataDTO, additionalHeaders={}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayQuoteQuote'), 
            'refreshValuation_TWIA', 
            [sessionId, quoteId, quoteDataDTO], 
            additionalHeaders);
    }

    static getMSBHoRenewalLaunchURL(sessionId, renewalId, additionalHeaders={}) {
        return JsonRPCService.send( 
            getProxiedServiceUrl('gatewayRenewalRenewal'), 
            'getMsbLaunchUrl_TWIA', 
            [sessionId, renewalId],
            additionalHeaders);
    }

    // TWIA PE - Unable to Launch MSB. MSB Valuation Failed
    // Service returns the MSB URL if provided by MSB when an MSB error occurs, which can happen when the
    // provided address isn't found by MSB
    static getForceMSBHoRenewalLaunchURL(sessionId, renewalId, additionalHeaders={}){
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayRenewalRenewal'), 
            'getForceMsbLaunchUrl_TWIA', 
            [sessionId, renewalId],
        additionalHeaders);
    }

    // DE17305
    static refreshRenewalMsbValuation(sessionId, quoteId, quoteDataDTO,additionalHeaders={}){
        // TWIACleanseObjUtil.resetAspectsNotVisibleValues(renewalVm);
        // const {value: renewal} = renewalVm;
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayRenewalRenewal'), 
            'refreshValuation_TWIA', 
            [sessionId, quoteId, quoteDataDTO],
        additionalHeaders);
    }

    static getMSBHoPolicyChangeLaunchURL(sessionId, policyChangeId, additionalHeaders={}) { 
        // Residential Policy Change - Construction Details
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayPolicyChange'), 
            'getMsbLaunchUrl_TWIA', 
            [sessionId, policyChangeId],
        additionalHeaders);
    }

    //TWIA PE - Unable to Launch MSB. MSB Valuation Failed
    // Service returns the MSB Valuation URL if provided by MSB when an MSB error occurs, which can happen when the
    // provided address isn't found by MSB
    static getForceMSBHoPolicyChangeLaunchURL(sessionId, policyChangeId, additionalHeaders={}) { // US12237 - Residential Policy Change - Construction Details
        return JsonRPCService.send( 
            getProxiedServiceUrl('gatewayPolicyChange'), 
            'getForceMsbLaunchUrl_TWIA', 
            [sessionId, policyChangeId], 
        additionalHeaders);
    }

    static refreshPolicyChangeMsbValuation(policyChangeVm, additionalHeaders={}){ 
        //Residential Policy Change - Construction Details
        // TWIACleanseObjUtil.resetAspectsNotVisibleValues(policyChangeVm);
        // const {value: policyChange} = policyChangeVm;
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayPolicyChange'), 
            'refreshValuation_TWIA', 
            [policyChangeVm.sessionUUID, policyChangeVm.jobID, policyChangeVm],
        additionalHeaders);
    }

    static getValuationReviewURL(quoteDataDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
           getProxiedServiceUrl('tfpaquoteutils'), 
           'getValuationReviewURL', 
           [quoteDataDTO],
           additionalHeaders);
    }

    static getUpdatedValuation(quoteDataDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('tfpaquoteutils'), 
            'getUpdatedValuation', 
            [quoteDataDTO],
            additionalHeaders);
    }

    static getReviewMSBUrl(policyNumber, additionalHeaders={}){
        return JsonRPCService.send(
            getProxiedServiceUrl('gatewayPolicy'),
            'getReviewMSBUrl',
            [policyNumber],
            additionalHeaders
        );
    }
}